import { call, put, takeLatest } from "redux-saga/effects";
import { PatientsAPI } from "../../../api/patientsAPI";
import { PatientDataUniqueType, ToastType } from "../../../utils/interfaces";
import {
  APPLY_TREATMENT_PLAN_REQUEST,
  CREATE_PATIENT_ERROR,
  CREATE_PATIENT_REQUEST,
  CREATE_PATIENT_SUCCESS,
  SET_TOAST
} from "../../actions";
import {ErrorMessageType} from "../../../types/errorMessages";

function* workerCreatePatient(action: {
  type: string;
  payload: { patientData: any; applyPlanData: any; navigate: Function };
}): Generator<any> {
  try {
    const { patientData, applyPlanData, navigate } = action.payload;
    const response: any = yield call(PatientsAPI.createPatient, patientData);
    yield put({
      type: CREATE_PATIENT_SUCCESS
    });
    if (applyPlanData) {
      yield put({
        type: APPLY_TREATMENT_PLAN_REQUEST,
        payload: {
          data: { ...applyPlanData, patientId: response.id },
          navigate
        }
      });
    } else {
      navigate(`/patients/view/${response.id}`);
    }
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "New patient is added successfully",
        type: ToastType.SUCCESS,
      }
    });
  } catch (error: any) {
    const errorMessage: ErrorMessageType = {
      text: '',
      type: ''
    };

    switch(true) {
      case error?.response?.data?.includes("uc_sensitivedata_phone"):
        errorMessage.text = "A user with this phone number already exists. Please use another phone number";
        errorMessage.type = PatientDataUniqueType.Phone;
        break;
      case error?.response?.data?.includes("uc_patient_externalid"):
        errorMessage.text = "A user with this ID already exists. Please use another external id";
        errorMessage.type = PatientDataUniqueType.ExternalID;
        break;
      case error?.response?.data?.includes("uc_appuser_name"):
        errorMessage.text = "A user with this login already exists. Please use another login";
        errorMessage.type = PatientDataUniqueType.Username;
        break;
      case error?.response?.data?.includes("uc_sensitivedata_email"):
        errorMessage.text = "A user with this email already exists. Please use another email";
        errorMessage.type = PatientDataUniqueType.Email;
        break;
      default:
        errorMessage.text = "Something went wrong, please check entered data and try again";
    }

    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: errorMessage.text,
        type: ToastType.ERROR,
      }
    });
    yield put({
      type: CREATE_PATIENT_ERROR,
      payload: { code: error.response.status, message: errorMessage }
    });
  }
}

export function* watcherCreatePatient() {
  yield takeLatest(CREATE_PATIENT_REQUEST, workerCreatePatient);
}
